import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as _ser from "../../../../_redux/_services/ApplicantsSlice";
import { SendEmailStartReducer } from "../../../../_redux/_services/UserManagerSlice";
import ApplicantCard from "../../../../components/ApplicantCard/ApplicantCard";
import {
  applicantCardTitleEnum,
  applicantCardTypeEnum,
  initialApplicantDetails,
} from "../../../../constants/constants";
import KeywordHighlighter from "../../../../components/KeywordHighlighter/KeywordHighlighter";
import { updateSnackbar } from "../../../../_redux/SnackbarSlice";

const initalState = { data: null, message: "", isloader: true };

const ApplicantsDetailsOverview = ({
  selectedApplicant,
  applicantDetails,
  docUrl,
  documentId,
  docName,
  onPropsReceive,
}) => {
  const [getDetails, setGetDetails] = useState(initialApplicantDetails);
  const [getJobCode, setGetJobCode] = useState(null);

  const dispatch = useDispatch();

  const AddAssociatedjobscode = useSelector(
    (state) => state.AddAssociatedjobs.data,
  );

  useEffect(() => {
    if (AddAssociatedjobscode === 200) {
      dispatch(_ser.addAssociatedjobsStartReducer(initalState));
    }
  }, [AddAssociatedjobscode]);

  useEffect(() => {
    if (selectedApplicant !== null) {
      setGetJobCode(selectedApplicant?.id);
    }
  }, [selectedApplicant]);

  useEffect(() => {
    if (applicantDetails) {
      console.log("applicantDetails +===================", applicantDetails);
      setGetDetails(applicantDetails);
    }
  }, [applicantDetails]);

  const sendEmail = useSelector((state) => state.SendEmail.data);

  useEffect(() => {
    if (sendEmail === 200) {
      dispatch(_ser.listNotesAsync(getJobCode));
      dispatch(SendEmailStartReducer(initalState));
    }
  }, [sendEmail]);

  const renderingUI = (object, cardType, title) => {
    let isAction = false,
      actionLink = null,
      nodata = "",
      type = "",
      isAddSection = false;
    switch (cardType) {
      case applicantCardTitleEnum.WORK_EXP:
        type = applicantCardTypeEnum.LIST_WITH_JUSTIFY;
        break;
      case applicantCardTitleEnum.EDUCATION_DETAILS:
        type = applicantCardTypeEnum.LIST_WITH_JUSTIFY;
        break;
      case applicantCardTitleEnum.CUSTOM_FIELDS_ARRAY:
        type = applicantCardTypeEnum.LIST_WITH_COLUMN;
        break;
      case applicantCardTitleEnum.CERTIFICATION:
      case applicantCardTitleEnum.SKILL_DETAILS:
        type = applicantCardTypeEnum.LIST;
        break;
    }

    const onReceivePropsHandler = (type) => {
      if (typeof type === "boolean") {
        onPropsReceive("loadApplicant");
      }
    };

    return (
      <ApplicantCard
        data={object}
        title={title}
        isAction={isAction}
        actionLink={actionLink}
        nodata={nodata}
        type={type}
        isAddSection={isAddSection}
        onReceiveProps={onReceivePropsHandler}
      />
    );
  };

  // const onDowloadHandler = async () => {
  //   try {
  //     const response = await fetch(docUrl, {
  //       method: "GET",
  //       credentials: "include",
  //     });
  //     if (!response.ok) throw new Error("Download failed");
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = docName || "document";
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //     dispatch(
  //       updateSnackbar({
  //         type: "success",
  //         message: "Document downloaded successfully",
  //       }),
  //     );
  //   } catch (err) {
  //     dispatch(
  //       updateSnackbar({
  //         type: "error",
  //         message: "Failed to download document",
  //       }),
  //     );
  //   }
  // };

  const onDowloadHandler = (getDetails) => {
    dispatch(
      _ser.downloaddocumentAsync(
        getDetails?.id,
        "download",
        documentId,
      ),)
}

  return (
    <>
      <Grid container spacing={3}>
        {getDetails && (
          <Grid item xs={12} sm={12} md={12} style={{ margin: "0 auto" }}>
            <div>
              {getDetails.workExp && getDetails.workExp.length > 0 && (
                <>
                  {renderingUI(
                    getDetails?.workExp,
                    applicantCardTitleEnum.WORK_EXP,
                    `${getDetails?.totalExperience ? `Work Experience (${getDetails?.totalExperience} years)` : "Work Experience"}`,
                  )}
                </>
              )}
              {getDetails.certification &&
                getDetails.certification.length > 0 && (
                  <>
                    {renderingUI(
                      getDetails?.certification,
                      applicantCardTitleEnum.CERTIFICATION,
                      "Certifications",
                    )}
                  </>
                )}
              {getDetails.educationDetails &&
                getDetails.educationDetails.length > 0 && (
                  <>
                    {renderingUI(
                      getDetails?.educationDetails,
                      applicantCardTitleEnum.EDUCATION_DETAILS,
                      "Education Details",
                    )}
                  </>
                )}
              {getDetails.customFieldsArray &&
                getDetails.customFieldsArray.length > 0 && (
                  <>
                    {renderingUI(
                      getDetails?.customFieldsArray,
                      applicantCardTitleEnum.CUSTOM_FIELDS_ARRAY,
                      "Additional Information",
                    )}
                  </>
                )}
            </div>
            {getDetails?.skillDetails &&
              getDetails?.skillDetails.length > 0 && (
                <div className="update_column_view">
                  {renderingUI(
                    getDetails?.skillDetails,
                    applicantCardTitleEnum.SKILL_DETAILS,
                    "Skills",
                  )}
                </div>
              )}
            <div className="attachement-view-section">
              <p className="titlesection">
                Attached Resume
                {docUrl && (
                  <span onClick={()=>onDowloadHandler(getDetails)}>
                    <div>
                      <svg
                        id="surface1"
                        xmlns="http://www.w3.org/2000/svg"
                        width="21.617"
                        height="23.966"
                        viewBox="0 0 21.617 23.966"
                      >
                        <path
                          id="Path_24419"
                          data-name="Path 24419"
                          d="M237.853,18.217H240.5l-4.049-4.26v2.851A1.409,1.409,0,0,0,237.853,18.217Zm0,0"
                          transform="translate(-225.381 -13.304)"
                          fill="#3b4046"
                        />
                        <path
                          id="Path_24420"
                          data-name="Path 24420"
                          d="M192.612,236.336a6.452,6.452,0,1,0,6.452,6.452A6.458,6.458,0,0,0,192.612,236.336Zm3.466,7-3.164,3.4a.432.432,0,0,1-.319.135.42.42,0,0,1-.313-.135l-3.158-3.4a.434.434,0,0,1,.022-.61.44.44,0,0,1,.615.022l2.419,2.591V239.17a.432.432,0,0,1,.864,0v6.171l2.408-2.591a.43.43,0,1,1,.626.589Zm0,0"
                          transform="translate(-177.446 -225.273)"
                          fill="#3b4046"
                        />
                        <path
                          id="Path_24421"
                          data-name="Path 24421"
                          d="M8.082,15.657H3.39a.432.432,0,1,1,0-.864H8.368a7.669,7.669,0,0,1,1.1-1.89H3.39a.432.432,0,0,1,0-.864h6.895a7.433,7.433,0,0,1,4.886-1.857c.178,0,.324.016.54.032V5.777H12.471A2.275,2.275,0,0,1,10.2,3.5V0H1.922A1.932,1.932,0,0,0,0,1.949V18.427a1.914,1.914,0,0,0,1.922,1.927H8.428a7.374,7.374,0,0,1-.345-4.7ZM3.39,9.34H8.86a.432.432,0,0,1,0,.864H3.39a.432.432,0,0,1,0-.864Zm0,0"
                          fill="#3b4046"
                        />
                      </svg>
                    </div>
                    Download
                  </span>
                )}
              </p>
              {docUrl ? (
                <div className="applicant-list-documentviewer">
                  <KeywordHighlighter file={docUrl} />
                </div>
              ) : (
                <h1
                  style={{
                    fontWeight: 300,
                    lineHeight: 1.2,
                    textAlign: "center",
                    margin: "60px 0px",
                    fontSize: "3rem",
                  }}
                >
                  No documents available
                </h1>
              )}
            </div>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default ApplicantsDetailsOverview;
